// Exports
export default {
	"feedbackForm": "feedbackForm_VeEEO",
	"feedbackEmail": "feedbackEmail_C1Rbx",
	"feedbackDescription": "feedbackDescription_5O9-C"
};
